import PatientPendingMessage from './PatientPendingMessage'

export default PatientPendingMessage



// WEBPACK FOOTER //
// ./src/legacy/components/PatientPendingMessage/index.js